<template>
  <div class="flex flex-col items-center">
    <div class="relative flex-1">
      <div class="pt-2 md:py-6">
        <div class="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
          <div class="flex h-screen flex-col items-center justify-center">
            <div class="mt-6 text-center">
              <img
                src="@/assets/images/503.png"
                class="object-cover"
                alt="Login Illustrator"
                style="height: 600px;"
              />
              <h1 class="font-mediun mt-12 text-2xl text-gray-900">
                Aplikasi Sedang Dimaintenance
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>

    <BaseConfirm :visible="unlocking" type="success" icon-type="badge" title="Masukkan kode maintenance" @close="unlocking = false" @confirmed="onUnlock">
        <template #content>
            <BaseInput fullwidth :shadow="false" placeholder="xxxxxxxx" type="text" v-model="token" />
        </template>
    </BaseConfirm>

    <Loading v-if="loading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BaseConfirm from '../components/base/BaseConfirm.vue';

export default {
    components: { BaseConfirm },
    data() {
        return {
            unlocking: false,
            token: null,
            loading: false
        }
    },
    methods: {
        ...mapActions({
            createAlert: 'alert/createAlert'
        }),
        onKeydown(e) {
            if (e.key.toLowerCase() === 'm' && e.ctrlKey && e.shiftKey) {
                e.preventDefault()

                this.unlocking = true
            }
        },
        async onUnlock() {
            this.loading = true

            const res = await fetch(`${process.env.VUE_APP_API_URL}/${this.token}`)

            if (!res.ok) {
                this.createAlert({
                    status: 'error',
                    data: 'Kode tidak valid'
                })
            } else {
                this.$router.push('/')
            }
            
            this.loading = false
        }
    },
    created() {
        document.addEventListener('keydown', this.onKeydown)
    },
    destroyed() {
        document.removeEventListener('keydown', this.onKeydown)
    },
    async beforeRouteEnter(to, from, next) {
        const res = await fetch('/api/v1')  

        if (res.status !== 503) {
            next('/')
        } else {
            next()
        }
    },
}
</script>